import React, { useState, useEffect } from 'react';
import { StyleSheet } from 'react-native';

interface OrderClosedPopupProps {
    closedBy: string;
    closedAt: string;
    onReturnToTables: () => void;
}

const OrderClosedPopup: React.FC<OrderClosedPopupProps> = ({ closedBy, closedAt, onReturnToTables }) => {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const styles = StyleSheet.create({
        overlay: {
            backgroundColor: 'rgba(51, 51, 51, 0.6)',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 1000,
        },
        popup: {
            width: windowSize.width > 900 ? windowSize.width * 0.4 : windowSize.width * 0.85,
            backgroundColor: '#ffffff',
            position: 'absolute',
            zIndex: 1001,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: 12,
            padding: 24,
        },
    });

    return (
        <>
            <div style={{ ...styles.overlay, width: windowSize.width, height: windowSize.height }} />
            <div style={styles.popup} className='popup-shadow ds-pop ds-pop--center'>
                <div className='d-flex flex-column align-items-center gap-3'>
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#A51B0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 16H12.01" stroke="#A51B0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M12 8V12" stroke="#A51B0D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <h5 style={{ color: '#2A2A37', margin: 0 }}>Order Closed</h5>
                    <p style={{ color: '#667085', textAlign: 'center', margin: 0 }}>
                        This order has been closed by <b>{closedBy}</b> on <b>{closedAt}</b>.
                    </p>
                    <button
                        className='btn btn-primary w-100'
                        style={{ backgroundColor: '#EE3A2A', borderColor: '#EE3A2A', borderRadius: 8, padding: '10px 0' }}
                        onClick={onReturnToTables}
                    >
                        Return to Tables
                    </button>
                </div>
            </div>
        </>
    );
};

export default OrderClosedPopup;
